<script>
import appConfig from "@/app.config";
import PageHeader from "@/components/page-header";
import Layout from "@/router/layouts/main";
import DatePicker from "vue2-datepicker";
import { Helper } from "@/mixin/helper";
import moment from "moment";

export default {
  page: {
    title: "Riwayat Pengiriman Email",
    meta: [{ name: "description", content: appConfig.description }],
  },
  components: {
    Layout,
    PageHeader,
    DatePicker,
  },
  mixins: [Helper],
  data() {
    return {
      periode: [
        moment().subtract(30, "days").format("YYYY-MM-DD"),
        moment().format("YYYY-MM-DD"),
      ],
      makeShortcuts: [
        { text: "Hari Ini", onClick: () => [new Date(), new Date()] },
        {
          text: "Kemarin",
          onClick: () => {
            const date = new Date();
            date.setTime(date.getTime() - 3600 * 1000 * 24);
            return [date, new Date()];
          },
        },
        {
          text: "30 Hari Terakhir",
          onClick: () => {
            const date = new Date();
            date.setTime(date.getTime() - 3600 * 1000 * 24 * 30);
            return [date, new Date()];
          },
        },
      ],
      pastDate: moment().subtract(1, "years"),
      futureEnd: moment().add(1, "years"),
      isMonth: true,
      emailState: {
        all: true,
        sent: false,
        partiallySent: false,
        fail: false,
        scheduled: false,
      },
      sentReport: {
        sentReport: [
          {
            id: 1,
            sentOn: "2023-01-19T12:42:30.000Z",
            category: "antrian",
            receiver:
              "Dino Riswanto, Alfian Yudistira, Elena Gunawan, Mustain Putra, Bimo Sebastian, Abimanyu Giarto, Andika Septian, Emanuel, Fredinan Gunawan, Yanto Hermanto, Ismail Drake, Suparman Astaji",
            status: "scheduled",
          },
          {
            id: 2,
            sentOn: "2023-01-16T12:42:30.000Z",
            category: "manual",
            receiver: "Dino Riswanto, Alfian Yudistira, Elena Gunawan",
            status: "sent",
          },
          {
            id: 3,
            sentOn: "2023-01-14T12:42:30.000Z",
            category: "manual",
            receiver:
              "Dino Riswanto, Alfian Yudistira, Elena Gunawan, Mustain Putra, Bimo Sebastian",
            status: "sent",
          },
          {
            id: 4,
            sentOn: "2023-01-11T15:31:24.000Z",
            category: "manual",
            receiver: "Fredinan Gunawan, Ismail Drake",
            status: "sent",
          },
          {
            id: 5,
            sentOn: "2023-01-11T12:42:30.000Z",
            category: "antrian",
            receiver:
              "Dino Riswanto, Alfian Yudistira, Elena Gunawan, Mustain Putra",
            status: "partiallySent",
          },
          {
            id: 6,
            sentOn: "2023-01-11T07:21:53.000Z",
            category: "manual",
            receiver: "Dino Riswanto, Abimanyu Giarto, Dika Septian",
            status: "sent",
          },
          {
            id: 7,
            sentOn: "2023-01-06T12:42:30.000Z",
            category: "manual",
            receiver:
              "Dino Riswanto, Alfian Yudistira, Elena Gunawan, Mustain Putra",
            status: "fail",
          },
        ],
      },
    };
  },
  computed: {
    title() {
      return "Riwayat Pengiriman Email";
    },
    items() {
      return [
        {
          text: "Laporan",
        },
        {
          text: "Pengingat Laporan",
        },
        {
          text: "Riwayat Pengiriman Email",
        },
      ];
    },
  },
  methods: {
    showAll() {
      let obj = { ...this.emailState };
      Object.keys(obj).forEach(function (key) {
        if (key !== "all") {
          obj[key] = false;
        } else {
          obj[key] = true;
        }
      });
      this.emailState = obj;
    },
    updateFilter(param) {
      this.emailState[param] = !this.emailState[param];
      if (param !== "all") {
        this.emailState.all = false;
      }
      let obj = { ...this.emailState };
      let objArr = [];
      Object.keys(obj).forEach(function (key) {
        if (obj[key]) {
          objArr.push(key);
        }
      });
      let exceptAll = Object.keys(obj).filter((key) => key != "all").length;
      if (
        objArr.length === exceptAll ||
        objArr.length === 0 ||
        objArr[0] === "all"
      ) {
        this.showAll();
      }
    },
    disabledRange: function (date) {
      return date <= this.pastDate || date >= this.futureEnd;
    },
    pickDate(date) {
      this.isMonth = !this.isMonth;
      const maxDay = 3;
      const maxMonth = 3;
      if (this.isMonth) {
        const currentDate = moment();
        const pastMonth = moment(currentDate).subtract(maxMonth, "M");
        this.pastDate = pastMonth;
        this.futureEnd = currentDate;
      } else {
        if (moment(date).diff(moment(this.pastDate), "days") < maxDay) {
          this.pastDate = Helper.methods.momentAdd(
            date,
            -(moment(date).diff(moment(this.pastDate)), "days"),
            "days"
          );
        } else {
          this.pastDate = Helper.methods.momentAdd(date, -maxDay, "day");
        }
        if (moment(new Date()).diff(moment(date), "days") < maxDay) {
          this.futureEnd = Helper.methods.momentAdd(
            date,
            moment(new Date()).diff(moment(date), "days") + 1,
            "days"
          );
        } else {
          this.futureEnd = Helper.methods.momentAdd(date, maxDay, "days");
        }
      }
    },
  },
};
</script>
<template>
  <Layout>
    <div class="mc-list-header">
      <PageHeader :title="title" :items="items" class="mc-page-three" />
      <div class="clearfix mc-btn-group__list mc-btn-group__list--detail">
        <div class="float-end">
          <b-button
            @click="$router.push({ name: 'Report Scheduler' })"
            variant="outline-primary"
            class="ms-3"
          >
            <i class="mc-fa icon-outline_arrow-left"></i>
            {{ $t("global.back") }}
          </b-button>
        </div>
      </div>
    </div>
    <div class="row mb-3">
      <div class="col-md-8">
        <div class="mc-table-filter__status pb-4">
          <b-button
            :variant="emailState.all ? 'secondary' : 'light'"
            size="sm"
            class="me-2"
            @click="updateFilter('all')"
          >
            Semua
          </b-button>
          <b-button
            :variant="emailState.sent ? 'secondary' : 'light'"
            size="sm"
            class="me-2"
            @click="updateFilter('sent')"
          >
            Terkirim
          </b-button>
          <b-button
            :variant="emailState.partiallySent ? 'secondary' : 'light'"
            size="sm"
            class="me-2"
            @click="updateFilter('partiallySent')"
          >
            Terkirim Sebagian
          </b-button>
          <b-button
            :variant="emailState.fail ? 'secondary' : 'light'"
            size="sm"
            class="me-2"
            @click="updateFilter('fail')"
          >
            Gagal
          </b-button>
          <b-button
            :variant="emailState.scheduled ? 'secondary' : 'light'"
            size="sm"
            class="me-2"
            @click="updateFilter('scheduled')"
          >
            Dijadwalkan
          </b-button>
        </div>
      </div>
      <div class="col-md-4 d-flex flex-row-reverse">
        <div class="mc-table-filter">
          <date-picker
            v-model="periode"
            placeholder="Pilih Tanggal"
            value-type="YYYY-MM-DD"
            format="DD MMM YYYY"
            :shortcuts="makeShortcuts"
            :clearable="false"
            range-separator=" - "
            range
            :disabled-date="disabledRange"
            @pick="pickDate"
          ></date-picker>
        </div>
      </div>
    </div>
    <div class="card">
      <div class="card-body">
        <div class="row">
          <!-- Search -->
          <div class="col-sm-12 col-md-12 d-flex flex-row-reverse">
            <div class="mc-table-view">
              <div
                id="tickets-table_filter"
                class="dataTables_filter text-md-end"
              >
                <label
                  class="d-inline-flex align-items-center mc-table-view__search"
                >
                  <i class="mc-fa fas fa-search"></i>
                  <b-form-input
                    v-model="filter"
                    type="search"
                    :placeholder="$t('global.search') + '...'"
                    class="form-control ms-2"
                    @input="searchData"
                  ></b-form-input>
                </label>
              </div>
            </div>
          </div>
          <!-- End search -->
        </div>
        <div class="card-body">
          <ul class="verti-timeline list-unstyled">
            <li
              class="event-list"
              v-for="data in sentReport.sentReport"
              :key="data.id"
              :class="data.status == 'scheduled' ? 'disabled' : ''"
            >
              <div class="event-timeline-dot">
                <i
                  class="mc-fa icon-outline_arrow-circle-right font-size-18"
                ></i>
              </div>
              <div class="d-flex">
                <div class="col-md-2">
                  <h5 class="font-size-14">
                    {{ momentDateShortMonth(data.sentOn) }} <br />
                    {{ momentTimeSeconds(data.sentOn) }}
                  </h5>
                </div>
                <div class="col-md-7">
                  <span
                    v-if="data.status == 'sent'"
                    class="badge rounded-pill font-size-11 badge-soft-success float-end"
                    >TERKIRIM</span
                  >
                  <span
                    v-if="data.status == 'partiallySent'"
                    class="badge rounded-pill font-size-11 badge-soft-warning float-end"
                    >TERKIRIM SEBAGIAN</span
                  >
                  <span
                    v-if="data.status == 'fail'"
                    class="badge rounded-pill font-size-11 badge-soft-danger float-end"
                    >GAGAL</span
                  >
                  <span
                    v-if="data.status == 'scheduled'"
                    class="badge rounded-pill font-size-11 badge-soft-secondary float-end"
                    >DIJADWALKAN</span
                  >
                  <h5>
                    <span
                      v-if="data.category == 'manual'"
                      class="mc-status mc-status--black"
                      ><strong>Manual</strong></span
                    >
                    <span v-else class="mc-status mc-status--blue"
                      ><strong>Antrian</strong></span
                    >
                  </h5>
                  <p>{{ data.receiver }}</p>
                </div>
              </div>
            </li>
            <li class="event-list">
              <div class="event-timeline-dot">
                <i class="mc-fa icon-fill_radio-button-on"></i>
              </div>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </Layout>
</template>
